module.exports = __webpack_public_path__ + "img/cards.a5ef15e2.png";